import { getDefaultConfig } from "@rainbow-me/rainbowkit";
import { http } from "viem";
import { enabledChains, toViemChain } from "./chains.js";

const projectId = import.meta.env.VITE_WALLETCONNECT_PROJECT_ID ?? "";

const chains = enabledChains().map(toViemChain);
const transports = Object.fromEntries(
  enabledChains().map((c) => [c.chainId, http(c.rpcUrl)]),
);

if (!projectId) {
   
  console.warn(
    "[atelier] VITE_WALLETCONNECT_PROJECT_ID is empty — WalletConnect modal will be unavailable. Injected wallets (MetaMask, etc.) still work.",
  );
}

export const wagmiConfig = getDefaultConfig({
  appName: "Atelier",
  projectId: projectId || "00000000000000000000000000000000",
  chains: chains.length > 0 ? (chains as [ReturnType<typeof toViemChain>, ...ReturnType<typeof toViemChain>[]]) : ([
    { id: 1, name: "Ethereum", nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 }, rpcUrls: { default: { http: ["https://cloudflare-eth.com"] } } },
  ] as never),
  transports,
  ssr: false,
});
